<div [attr.data-testid]="testIds.generalSettingsContainer">
  <div class="avatar-container">
    @if (avatarFile || avatarUrl) {
      <img class="room-avatar-image" [src]="userService.getUrlForFile(avatarFile, avatarUrl, roomId()!)" alt="" />
    } @else {
      <mat-icon class="room-avatar-image" svgIcon="default-user-icon"></mat-icon>
    }
    @if (roomPowerLevelService.canDoEvent(EventType.RoomAvatar, powerLevel, userId)) {
      <mat-icon
        [attr.data-testid]="testIds.buttonEditAvatar"
        tabindex="0"
        (click)="fileInput.click()"
        (keydown.enter)="fileInput.click()"
        class="edit-icon"
        svgIcon="edit"></mat-icon>
    }
    <input #fileInput (change)="onFileSelected($event)" class="file-input" type="file" />
  </div>
  <fieldset class="chat-data">
    <legend>Chatdaten</legend>
    <form [formGroup]="chatForm" class="chat-data-form">
      <mat-label class="chat-label">Chatname</mat-label>
      <mat-form-field appearance="outline" class="form-field">
        <input formControlName="chatname" id="chatname" matInput placeholder="Chatname" />
      </mat-form-field>
      <mat-label class="chat-label">Beschreibung</mat-label>
      <mat-form-field appearance="outline" class="form-field">
        <input formControlName="chattheme" id="chatdescription" matInput placeholder="Beschreibung" />
      </mat-form-field>
    </form>
    <mat-label class="chat-label">Mitglieder</mat-label>
    <div class="members-table-container">
      <table [dataSource]="dataSource()" class="mat-elevation-z0 members-table" mat-table>
        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let element" class="col-avatar" mat-cell>
            @let userAvatar = (userService.userCache | async)!.get(element.mxid);
            @if (userAvatar) {
              <img class="member-avatar" [src]="userAvatar" alt="Avatar" />
            } @else {
              <mat-icon svgIcon="default-user-icon"></mat-icon>
            }
          </td>
        </ng-container>
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let element" mat-cell>
            <mat-label class="member-name">{{ element.name }}</mat-label>
            @if (getCreator() === element.mxid || element.mxid === accountService.getMyMxId()) {
              <div class="member-details">
                @if (getCreator() && getCreator() === element.mxid) {
                  <div class="creator">Ersteller</div>
                }
                @if (element.mxid === accountService.getMyMxId()) {
                  <div class="self">Sie</div>
                }
              </div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="timAdress">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let element" mat-cell>TIM-Adresse: {{ element.mxid }}</td>
        </ng-container>
        <ng-container matColumnDef="kick">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let element" class="col-kick" mat-cell>
            @if (element.mxid !== userId && roomPowerLevelService.canDoAction('kick', powerLevel, userId)) {
              <button mat-icon-button (click)="kick(element)">
                <mat-icon
                  svgIcon="user-minus"
                  [attr.data-testid]="testIds.iconKickMember"
                  class="kick-icon"
                  matTooltip="Teilnehmer entfernen"></mat-icon>
              </button>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="addBtn">
          <td *matFooterCellDef colspan="4" mat-footer-cell>
            <app-invite-mxid-dialog
              [customBtnWidth]="'100%'"
              [isDisabled]="!roomPowerLevelService.canDoAction('invite', powerLevel, userId)"
              [roomId]="roomId()!"></app-invite-mxid-dialog>
          </td>
        </ng-container>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row [matTooltip]="row.mxid"></tr>
        <tr *matFooterRowDef="['addBtn']" mat-footer-row></tr>
      </table>
    </div>
  </fieldset>
  <div class="btn-container">
    <app-button
      [dataTestId]="testIds.buttonSaveGeneral"
      (click)="save()"
      onKeyUp="save()"
      [isPrimary]="true"
      [isDisabled]="!canSave(powerLevel)"
      text="Speichern"></app-button>
  </div>
</div>
